import { Button, ButtonProps } from "@chakra-ui/react";

export const MediumBtn = (props: ButtonProps) => {
  return (
    <Button
      fontSize="15px"
      type="submit"
      bg="teal.300"
      w={{ xl: "150px", "2xl": "150px", sm: "100px" }}
      h="45"
      mb="20px"
      color="white"
      mt="20px"
      _hover={{
        bg: "teal.200",
      }}
      _active={{
        bg: "teal.400",
      }}
      {...props}
    />
  );
};
